export const getSectionCategoryPrefixes = (
  sectionCategoryIdentifiers: number[] = []
): number[] =>
  sectionCategoryIdentifiers.map((identifier) =>
    parseInt(identifier.toString().charAt(0))
  );
